export const PROFILE_DETAILS_TABS = Object.freeze({
  profile: 'profile',
  accounts: 'accounts',
  transactions: 'transactions',
  partnership: 'partnership',
  trades: 'trades',
  kyc: 'kyc',
  verification: 'verification',
  compliance: 'compliance',
  documents: 'documents',
  actionLog: 'actionLog',
  internalMail: 'internalMail',
});

export function buildProfileDetailsTabs() {
  return [
    { key: PROFILE_DETAILS_TABS.profile, label: 'profiles.tabProfileInfo' },
    { key: PROFILE_DETAILS_TABS.accounts, label: 'profiles.tabAccounts' },
    { key: PROFILE_DETAILS_TABS.transactions, label: 'profiles.tabTransactions' },
    { key: PROFILE_DETAILS_TABS.partnership, label: 'profiles.tabPartnership' },
    { key: PROFILE_DETAILS_TABS.trades, label: 'profiles.tabTrades' },
    { key: PROFILE_DETAILS_TABS.kyc, label: 'profiles.tabKyc' },
    { key: PROFILE_DETAILS_TABS.verification, label: 'profiles.tabVerification' },
    { key: PROFILE_DETAILS_TABS.compliance, label: 'profiles.tabCompliance' },
    { key: PROFILE_DETAILS_TABS.documents, label: 'profiles.tabDocuments' },
    { key: PROFILE_DETAILS_TABS.actionLog, label: 'profiles.tabActionLog' },
    { key: PROFILE_DETAILS_TABS.internalMail, label: 'profiles.tabInternalMail' },
  ];
}
